import type { FC } from 'react';
import { useHydrogenFcfsRoot } from 'src/apis/hydrogen-fcfs/use-hydrogen-fcfs-root';
import type { ActiveSection } from 'src/components/layout/header/types';
import { Link } from 'src/components/navigation/link';
import { Forbidden } from 'src/utils/errors';

export const isH2Active = (pathname: string) => pathname.startsWith('/h2');

export const SecondaryNavH2: FC<{ activeSection: ActiveSection }> = ({
  activeSection,
}) => {
  const hydrogenFcfsRoot = useHydrogenFcfsRoot();

  if (!activeSection.h2 || (hydrogenFcfsRoot && !hydrogenFcfsRoot.response))
    return null;

  if (!hydrogenFcfsRoot?.response) {
    throw new Forbidden();
  }

  return (
    <div
      className={`
        flex flex-col flex-wrap items-stretch gap-x-xl gap-y-md
        md:flex-row md:items-center
        legacy:gap-x-[2rem] legacy:gap-y-[1rem]
      `}
      data-testid="secondary-nav"
    >
      {hydrogenFcfsRoot.response.data._links?.bookingNetworkPoints && (
        <Link mode="secondary" to="/h2/fcfs/booking">
          H2 FCFS
        </Link>
      )}
      {hydrogenFcfsRoot.response.data._links?.bookingOverviewShipper && (
        <Link mode="secondary" to="/h2/fcfs/shipper-bookings">
          My Booking Requests
        </Link>
      )}
      {hydrogenFcfsRoot.response.data._links?.bookingOverviewOperator && (
        <Link mode="secondary" to="/h2/fcfs/operator-bookings">
          Shipper Booking Requests
        </Link>
      )}
      {hydrogenFcfsRoot.response.data._links?.interactingUsersOverview && (
        <Link mode="secondary" to="/h2/fcfs/interacting-users">
          Interacting Users
        </Link>
      )}
      <Link mode="secondary" to="/h2/network-points">
        H2 Network Points
      </Link>
    </div>
  );
};
